export default __webpack_public_path__ + "static/web_img1-62de1d914ecc5fe702c2cfb9840e8d53.webp";